<div class="pagina-ficha">
  <div class="faixa-somente-leitura" role="status" *ngIf="somenteLeitura && !fichaBloqueada">
    <mat-icon class="faixa-icone">lock</mat-icon>
    <span>
      <strong>{{ motivoSomenteLeitura }}.</strong>
      {{ complementoSomenteLeitura }}
    </span>
  </div>
  <div class="cabecalho-obra" [class.cabecalho-bloqueio]="fichaBloqueada">
    <div class="cabecalho-topo">
      <button class="btn btn-voltar" type="button" (click)="voltarParaBusca()">
        <mat-icon>arrow_back</mat-icon>
        Voltar para a busca
      </button>
      <div class="navegacao-obras">
        <button class="btn btn-icon arrow-icon-btn" type="button" (click)="voltarObra()" [disabled]="!podeVoltar" [title]="podeVoltar ? 'Obra anterior' : 'Não há obra anterior'">
          <mat-icon class="ficha-icon">arrow_back</mat-icon>
        </button>
        <button class="btn btn-icon arrow-icon-btn" type="button" (click)="avancar()" [disabled]="!podeAvancar" [title]="podeAvancar ? 'Próxima obra' : 'Não há próxima obra'">
          <mat-icon class="ficha-icon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>

    <div class="cabecalho-conteudo" *ngIf="detalheDaObraComponent?.ArrObraDetalhes">
      <div class="imagem-obra">
        <img *ngIf="detalheDaObraComponent?.imagemPrincipalObra" [src]="detalheDaObraComponent?.imagemPrincipalObra?.url" [alt]="detalheDaObraComponent?.imagemPrincipalObra?.alt || 'Foto da obra'">
        <div *ngIf="!detalheDaObraComponent?.imagemPrincipalObra" class="sem-imagem">
          <mat-icon>apartment</mat-icon>
        </div>
      </div>
      <div class="titulo-obra">
        <div class="titulo-linha">
          <h1>{{ detalheDaObraComponent?.ArrObraDetalhes?.name }}</h1>
          <span class="tag tag-id">ID {{ detalheDaObraComponent?.ArrObraDetalhes?.id }}</span>
        </div>
        <div class="tags-obra">
          <span class="tag tag-modulo">{{ getModuleName(detalheDaObraComponent?.ArrObraDetalhes?.moduleId) }}</span>
          <span *ngIf="detalheDaObraComponent?.ArrObraDetalhes?.categories?.[0]?.name" class="tag tag-tipo">{{ detalheDaObraComponent?.ArrObraDetalhes?.categories?.[0]?.name }}</span>
          <span class="tag tag-fase">{{ detalheDaObraComponent?.ArrObraDetalhes?.phase }}</span>
          <span *ngIf="detalheDaObraComponent?.ArrObraDetalhes?.city || detalheDaObraComponent?.ArrObraDetalhes?.state" class="tag tag-local">{{ detalheDaObraComponent?.ArrObraDetalhes?.city || '' }}{{ detalheDaObraComponent?.ArrObraDetalhes?.city && detalheDaObraComponent?.ArrObraDetalhes?.state ? ' · ' : '' }}{{ detalheDaObraComponent?.ArrObraDetalhes?.state || '' }}</span>
        </div>
        <a class="endereco-obra" *ngIf="detalheDaObraComponent?.enderecoFormatado && detalheDaObraComponent?.ArrObraDetalhes?.locationUrl" [href]="detalheDaObraComponent?.ArrObraDetalhes?.locationUrl" target="_blank" rel="noopener noreferrer" [title]="detalheDaObraComponent?.enderecoCompleto">
          <mat-icon class="endereco-icone" fontSet="material-symbols-outlined">location_on</mat-icon>
          <span class="endereco-texto">{{ detalheDaObraComponent?.enderecoFormatado }}</span>
        </a>
      </div>
      <div class="botoes-cabecalho">
        <button class="btn btn-acao" type="button" (click)="abrirCriarTarefa()" [disabled]="somenteLeitura" [title]="somenteLeitura ? dicaSomenteLeitura : 'Adicionar tarefa'">
          <mat-icon>add_task</mat-icon>
          Tarefa
        </button>
        <button class="btn btn-acao" type="button" (click)="detalheDaObraComponent?.downloadPDFFicha()">
          <mat-icon>picture_as_pdf</mat-icon>
          PDF
        </button>
        <button class="btn btn-acao" type="button" (click)="detalheDaObraComponent?.abrirFichaImpressao()">
          <mat-icon>print</mat-icon>
          Imprimir
        </button>
        <button class="btn btn-acao" type="button" (click)="openPanel('reportar-erro')" [disabled]="somenteLeitura" [title]="somenteLeitura ? dicaSomenteLeitura : 'Reportar erro'">
          <mat-icon fontSet="material-symbols-outlined">flag</mat-icon>
          Reportar
        </button>
      </div>
    </div>

    <div class="estatisticas-obra" *ngIf="detalheDaObraComponent?.ArrObraDetalhes">
      <div class="estatistica">
        <div class="estatistica-header">
          <mat-icon fontSet="material-symbols-outlined" class="estatistica-icone">history</mat-icon>
          <span class="estatistica-label">Ficha atualizada</span>
        </div>
        <span class="estatistica-valor">{{ detalheDaObraComponent?.dataAtualizacaoFormatada }}</span>
      </div>
      <div class="estatistica">
        <div class="estatistica-header">
          <mat-icon fontSet="material-symbols-outlined" class="estatistica-icone">calendar_month</mat-icon>
          <span class="estatistica-label">Término</span>
        </div>
        <span class="estatistica-valor" [class.estatistica-valor-vazio]="detalheDaObraComponent?.dataTerminoFormatada === 'Não informado'">{{ detalheDaObraComponent?.dataTerminoFormatada }}</span>
      </div>
      <div class="estatistica">
        <div class="estatistica-header">
          <mat-icon fontSet="material-symbols-outlined" class="estatistica-icone">timelapse</mat-icon>
          <span class="estatistica-label">Fase</span>
        </div>
        <span class="estatistica-valor">{{ detalheDaObraComponent?.ArrObraDetalhes?.phase }}</span>
      </div>
      <div class="estatistica">
        <div class="estatistica-header">
          <mat-icon fontSet="material-symbols-outlined" class="estatistica-icone">contacts</mat-icon>
          <span class="estatistica-label">Contatos</span>
        </div>
        <span class="estatistica-valor">{{ contatosComponent?.totalContatos }}</span>
      </div>
      <div class="estatistica">
        <div class="estatistica-header">
          <mat-icon fontSet="material-symbols-outlined" class="estatistica-icone">task</mat-icon>
          <span class="estatistica-label">Tarefas abertas</span>
        </div>
        <span class="estatistica-valor">{{ tarefasRelatosComponent?.totalTarefasAbertas }}</span>
      </div>
    </div>
  </div>


  <app-ficha-bloqueada *ngIf="fichaBloqueada" [moduloId]="moduloBloqueadoId"></app-ficha-bloqueada>

  <div class="conteudo-ficha">
    <app-detalhe-da-obra
      style="display: contents"
      [idObra]="idObra"
      [moduloId]="moduloId"
      [contextoResultado]="contextoResultado"
      (loadingObra)="onLoadingObra($event)"
      (moduleIdLoaded)="onModuleIdLoaded($event)"
      (obraNameLoaded)="onObraNameLoaded($event)"
      (fichaBloqueada)="onFichaBloqueada($event)"
    ></app-detalhe-da-obra>

    <div class="coluna-esquerda" *ngIf="!fichaBloqueada">
      <div class="card-secao card-numeros-obra" *ngIf="detalheDaObraComponent?.numerosResumo?.length">
        <div class="card-secao-titulo numeros-titulo">
          <div class="titulo-com-link">
            <mat-icon class="ficha-icon">list_alt</mat-icon>
            Números da obra<ng-container *ngIf="detalheDaObraComponent?.tipoObra"> — {{ detalheDaObraComponent?.tipoObra }}</ng-container>
          </div>
        </div>
        <div class="grid-numeros">
          <div class="numero-item" *ngFor="let numero of detalheDaObraComponent?.numerosResumo" [style.order]="detalheDaObraComponent?.ordemNumero(numero.label)">
            <span class="numero-label">{{ numero.label }}</span>
            <span class="numero-valor">{{ numero.value }}</span>
          </div>
          <ng-container *ngFor="let categoria of detalheDaObraComponent?.ArrObraDetalhes?.categories">
            <ng-container *ngIf="!detalheDaObraComponent?.ehCronograma(categoria) && !detalheDaObraComponent?.ehCategoriaUnidades(categoria)">
              <div class="numero-item" *ngFor="let key of detalheDaObraComponent?.getKeys(categoria.values)" [style.order]="detalheDaObraComponent?.ordemNumero(key)" [class.numero-item-largo]="detalheDaObraComponent?.isValorLivre(key) || detalheDaObraComponent?.temVariasOpcoes(categoria.name, categoria.values[key])">
                <span class="numero-label">{{ detalheDaObraComponent?.getLabelCategoria(key) }}</span>
                <ng-container *ngIf="detalheDaObraComponent?.temVariasOpcoes(categoria.name, categoria.values[key]); else valorNormal">
                  <div class="tags-list">
                    <span class="tag" *ngFor="let opcao of detalheDaObraComponent?.getOpcoes(categoria.values[key])">{{ opcao }}</span>
                  </div>
                </ng-container>
                <ng-template #valorNormal>
                  <span class="numero-valor" [class.numero-valor-texto]="detalheDaObraComponent?.isValorLivre(key)" [innerHTML]="detalheDaObraComponent?.formatarValorNumeros(key, categoria.values[key]) | nl2br"></span>
                </ng-template>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <ng-container *ngFor="let categoria of detalheDaObraComponent?.ArrObraDetalhes?.categories">
          <div class="categorias" *ngIf="detalheDaObraComponent?.ehCategoriaUnidades(categoria)">
            <div class="titulo-categoria">
              <mat-icon fontSet="material-symbols-outlined">folder</mat-icon>
              <span>{{ categoria.name }}</span>
            </div>
            <ng-container *ngIf="detalheDaObraComponent?.itensUnidade(categoria) as unidades">
              <div class="tabela-unidades-wrapper">
                <table class="tabela-unidades">
                  <thead>
                    <tr>
                      <th></th>
                      <th *ngFor="let coluna of detalheDaObraComponent?.colunasUnidades(unidades)">{{ coluna }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let unidade of unidades">
                      <td class="unidade-rotulo">{{ unidade.rotulo }}</td>
                      <td *ngFor="let coluna of detalheDaObraComponent?.colunasUnidades(unidades)">
                        <span class="numero-valor">{{ detalheDaObraComponent?.valorUnidade(unidade.detalhes, coluna) }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </div>
          <div class="categorias" *ngIf="detalheDaObraComponent?.ehCronograma(categoria)">
            <div class="titulo-categoria">
              <mat-icon fontSet="material-symbols-outlined">folder</mat-icon>
              <span>{{ categoria.name }}</span>
            </div>
            <ol class="lista-timeline" [class.recolhido]="!cronogramaExpandido">
              <li *ngFor="let item of detalheDaObraComponent?.cronogramaItens(categoria)">
                <time *ngIf="item.data">{{ item.data }}</time>
                <span>{{ item.texto }}</span>
              </li>
            </ol>
            <button type="button" class="btn-ver-mais" (click)="cronogramaExpandido = !cronogramaExpandido">
              {{ cronogramaExpandido ? 'Ver menos' : 'Ver mais' }}
            </button>
          </div>
        </ng-container>
      </div>

      <div class="card-secao card-downloads" *ngIf="detalheDaObraComponent?.ArrListaArquivos?.length">
        <div class="card-secao-titulo">
          <mat-icon class="ficha-icon">download</mat-icon>
          Downloads
        </div>
        <ng-container *ngFor="let arquivo of detalheDaObraComponent?.ArrListaArquivos">
          <a class="download-link" *ngIf="arquivo.fileName" (click)="detalheDaObraComponent?.baixarPDF(arquivo)">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>{{ arquivo.fileDescription || arquivo.fileName || 'Baixar arquivo' }}</span>
          </a>
        </ng-container>
      </div>

      <div class="card-secao card-fotos" *ngIf="detalheDaObraComponent?.produtoProductImages?.length">
        <div class="card-secao-titulo">
          <mat-icon class="ficha-icon">photo_library</mat-icon>
          Fotos da obra
        </div>
        <div class="fotos-grid">
          <img
            *ngFor="let foto of detalheDaObraComponent?.produtoProductImages; let i = index"
            class="foto-item"
            [src]="foto.url"
            [alt]="foto.alt"
            (click)="detalheDaObraComponent?.openImageModal(i)"
          />
        </div>
      </div>

      <div class="imagem-modal" *ngIf="detalheDaObraComponent?.isImageModalOpen" (click)="detalheDaObraComponent?.closeImageModal()">
        <div class="imagem-modal-content" (click)="$event.stopPropagation()">
          <button class="anterior" type="button" (click)="detalheDaObraComponent?.prevImage($event)">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <img
            class="imagem-grande"
            [src]="detalheDaObraComponent?.produtoProductImages[detalheDaObraComponent?.currentIndex]?.url"
            [alt]="detalheDaObraComponent?.produtoProductImages[detalheDaObraComponent?.currentIndex]?.alt"
          />
          <button class="proxima" type="button" (click)="detalheDaObraComponent?.nextImage($event)">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>

      <div class="card-secao card-ultimas-atualizacoes" *ngIf="detalheDaObraComponent?.ArrObraDetalhes?.recentUpdates?.length">
        <div class="card-secao-titulo">
          <mat-icon class="ficha-icon">newspaper</mat-icon>
          Últimas atualizações
        </div>
        <div class="lista-atualizacoes">
          <div class="atualizacao" *ngFor="let atualizacao of detalheDaObraComponent?.ArrObraDetalhes?.recentUpdates">
            <div class="atualizacao-linha">
              <div class="atualizacao-marcador"></div>
              <div class="atualizacao-data">
                <span class="atualizacao-dia">{{ atualizacao.date | date:'dd' }}</span>
                <span class="atualizacao-mes">{{ atualizacao.date | date:'MMM' | lowercase }}</span>
                <span class="atualizacao-hora">{{ atualizacao.date | date:'HH:mm' }}</span>
              </div>
              <div class="atualizacao-conteudo">
                <strong>{{ atualizacao.title }}</strong>
                <p *ngIf="atualizacao.detail">{{ atualizacao.detail }}</p>
                <p *ngIf="!atualizacao.detail && atualizacao.userName" class="atualizacao-autor">por {{ atualizacao.userName }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="coluna-direita" *ngIf="!fichaBloqueada">
      <div class="card-secao card-acompanhamento" [class.bloqueado]="somenteLeitura" *ngIf="detalheDaObraComponent">
        <h3 class="card-secao-titulo"><mat-icon class="ficha-icon">person</mat-icon> Meu acompanhamento</h3>

        <div class="linha-dupla">
          <div class="campo-acompanhamento">
            <label>Responsável</label>
            <app-filtro-responsavel
              [responsaveis]="detalheDaObraComponent?.responsavel"
              [value]="detalheDaObraComponent?.responsavelSelecionado"
              (valueChange)="onResponsavelChange($event)"
              placeholder="Selecione o responsável"
              placeholderBusca="Buscar responsável"
            ></app-filtro-responsavel>
          </div>

          <div class="campo-acompanhamento">
            <label>Situação</label>
            <select class="form-control" [disabled]="somenteLeitura" [ngModel]="detalheDaObraComponent?.statusSelecionado" (ngModelChange)="onSituacaoChange($event)">
              <option [ngValue]="null" disabled>Selecione a situação</option>
              <option *ngFor="let s of (detalheDaObraComponent?.ArrClienteMercado || [])" [ngValue]="s.id">{{ s.description }}</option>
            </select>
          </div>
        </div>

        <div class="campo-acompanhamento">
          <div class="potencial-linha">
            <label class="potencial-label">Potencial</label>
            <div class="rating">
              <span
                *ngFor="let star of (detalheDaObraComponent?.stars || []); let i = index"
                (click)="detalheDaObraComponent?.rate(i + 1)"
                (mouseenter)="detalheDaObraComponent?.hover(i + 1)"
                (mouseleave)="detalheDaObraComponent?.hover(0)"
                class="star"
                [ngClass]="{ filled: i + 1 <= ((detalheDaObraComponent?.hovered || 0) || (detalheDaObraComponent?.score || 0)) }"
              >
                <ng-container *ngIf="i + 1 <= ((detalheDaObraComponent?.hovered || 0) || (detalheDaObraComponent?.score || 0))">&#9733;</ng-container>
                <ng-container *ngIf="i + 1 > ((detalheDaObraComponent?.hovered || 0) || (detalheDaObraComponent?.score || 0))">&#9734;</ng-container>
              </span>
            </div>
            <div class="botoes-situacao">
              <button class="btn btn-situacao" type="button" [disabled]="somenteLeitura" (click)="detalheDaObraComponent?.openPanel('contratada')" title="Contratada">
                <mat-icon fontSet="material-symbols-outlined" class="icon-situacao icon-contratada">thumb_up</mat-icon>
              </button>
              <button class="btn btn-situacao" type="button" [disabled]="somenteLeitura" (click)="detalheDaObraComponent?.openPanel('perdida')" title="Perdida">
                <mat-icon fontSet="material-symbols-outlined" class="icon-situacao icon-perdida">thumb_down</mat-icon>
              </button>
              <button class="btn btn-situacao" type="button" [disabled]="somenteLeitura" (click)="detalheDaObraComponent?.openPanel('descartada')" title="Descartada">
                <mat-icon fontSet="material-symbols-outlined" class="icon-situacao icon-descartada">delete</mat-icon>
              </button>
            </div>
          </div>
          <div class="success-message" *ngIf="detalheDaObraComponent?.successMessagePotencial">
            {{ detalheDaObraComponent?.successMessagePotencial }}
          </div>
        </div>

        <div class="success-message" *ngIf="detalheDaObraComponent?.successMessage">
          {{ detalheDaObraComponent?.successMessage }}
        </div>
      </div>

      <div class="card-secao card-contatos" *ngIf="detalheDaObraComponent">
        <div class="card-secao-titulo">
          <mat-icon class="ficha-icon">contacts</mat-icon>
          Contatos
        </div>
        <app-contatos
          [idObra]="idObra"
          [idModulo]="moduloId"
          [somenteLeitura]="somenteLeitura"
          [workName]="obraName"
          [moduleName]="getModuleName(moduloId)"
          [companyId]="companyId"
          [companyName]="companyName"
          (loading)="onPainelLoading($event)"
        ></app-contatos>
      </div>

      <div class="card-secao card-atividade">
        <div class="atividade-topo">
          <h3 class="card-secao-titulo"><mat-icon class="ficha-icon">chat</mat-icon> Atividade</h3>
          <div class="botoes-nova-atividade">
            <button class="btn btn-nova" type="button" (click)="abrirCriarTarefa()" [disabled]="somenteLeitura" [title]="somenteLeitura ? dicaSomenteLeitura : 'Nova tarefa'">
              <mat-icon>add_task</mat-icon>
              Nova tarefa
            </button>
            <button class="btn btn-nova" type="button" (click)="abrirNovoRelato()" [disabled]="somenteLeitura" [title]="somenteLeitura ? dicaSomenteLeitura : 'Novo relato'">
              <mat-icon>description</mat-icon>
              Novo relato
            </button>
          </div>
        </div>
        <app-tarefas-relatos
          [idObra]="idObra"
          [somenteLeitura]="somenteLeitura"
          (editar)="openPanel('editar-tarefa', $event)"
          (editarRelato)="openPanel('editar-relato', $event)"
          (concluir)="openPanel('conclusao-tarefa', $event)"
          (abrirDescarteTarefa)="abrirPainelDescarteTarefa($event)"
          (abrirDescarteRelato)="abrirPainelDescarteRelato($event)"
        ></app-tarefas-relatos>
      </div>
    </div>
  </div>
</div>

<div class="modal-painel-tarefa" *ngIf="isPanelOpen && isModalPanel">
  <div class="modal-painel-backdrop" (click)="closePanel()"></div>
  <div class="modal-painel-content" [class.modal-painel-conclusao]="currentPanel === 'conclusao-tarefa'">
    <div class="modal-painel-body">
      <app-editar-tarefa
        *ngIf="currentPanel === 'editar-tarefa'"
        [tarefa]="tarefaSelecionada"
        (close)="closePanel()"
        [idObra]="idObra"
        [idModulo]="moduloId"
        (tarefaEditada)="onTarefaEditada()"
        (loading)="onPainelLoading($event)"
      ></app-editar-tarefa>
      <app-editar-relato
        *ngIf="currentPanel === 'editar-relato'"
        [relato]="tarefaSelecionada"
        (close)="closePanel()"
        [idObra]="idObra"
        [moduloId]="moduloId"
        (relatoEditado)="onRelatoEditado()"
        (loading)="onPainelLoading($event)"
      ></app-editar-relato>
      <app-conclusao-tarefa
        *ngIf="currentPanel === 'conclusao-tarefa'"
        (close)="closePanel()"
      ></app-conclusao-tarefa>
    </div>
  </div>
</div>

<app-common-loader *ngIf="isLoadingObra"></app-common-loader>